import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import "../css/login.css";
import Pwd from './forgot_pwd';
import { Card, Box, Button, CardContent, Typography, InputAdornment, IconButton, Avatar, useTheme } from "@mui/material";
import Icon from "@mdi/react";
import { mdiEye, mdiEyeOff } from "@mdi/js";
import { clearRememberedUsers, getRememberedUsers, setRememberedUsers } from "../rememberedUsers";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "../compo/LanguageSwitcher";
import DynamicField from "../compo/form_fields";

const Login = (props) => {
    const param = props.param;
    const { t, i18n } = useTranslation();
    const isRtl = i18n.language?.startsWith('ar');
    const version = require("../version.json");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const passwordRef = useRef(null);
    const rememberedUsers = getRememberedUsers();
    const [rememberedUsersList, setRememberedUsersList] = useState(getRememberedUsers());
    const theme = useTheme();

    document.title = param.webApp + " " + version[0].build;


    const handleSubmit = async (e) => {
        e.preventDefault();
        var Gfunc = require('../Gfunc');
        await axios({
            method: 'POST',
            url: param.urlService + 'auth.php',
            headers: { 'content-type': 'application/json', 'appID': param.appID },
            data: JSON.stringify({ login: email, password: password }),
        })
            .then(response => {
                if (response.data.err) {
                    alert(response.data.err)
                } else {
                    Gfunc.axiosResponse(response, () => {
                        localStorage.setItem('build', version[0].build);
                        localStorage.setItem('token', response.data.jData.token);
                        localStorage.setItem('isLoged', true);
                        localStorage.setItem('name', response.data.jData.name);
                        localStorage.setItem('nickname', response.data.jData.nickname);
                        localStorage.setItem('email', response.data.jData.email);
                        localStorage.setItem('uid', response.data.jData.id);
                        localStorage.setItem('param', JSON.stringify({ 'urlService': param.urlService, 'appID': param.appID }));
                        localStorage.setItem('profileImage', param.urlimg + "user/" + response.data.jData.id + ".jpg");
                        localStorage.setItem('img', response.data.jData.img);
                        localStorage.setItem('nodes', JSON.stringify(response.data.jData.nodes));
                        window.location = ('/');
                    });
                }
            })
            .catch(error => {
                alert(error);
                setEmail('');
                setPassword('');
            })
    }

    useEffect(() => {
        if (!email) {
            setSelectedUser(null);
        } else {
            // check if typed email / nickname matched any remembered user
            const matchedUser = rememberedUsers.find(
                user => (user.nickname || user.email) === email
            );
            if (matchedUser) {
                setSelectedUser(matchedUser);
            } else {
                setSelectedUser(null);
            }
        }
    }, [email, rememberedUsers]);



    useEffect(() => {
        const inputs = document.querySelectorAll('input[type="password"], input[type="text"]');
        const checkAutofill = () => {
            inputs.forEach(input => {
                if (input.matches(':-webkit-autofill')) {
                    const label = document.querySelector(`label[for="${input.id}"]`);
                    if (label) {
                        label.setAttribute('data-shrink', 'true');
                        label.classList.add('MuiInputLabel-shrink');
                    }
                }
            });
        };
        setTimeout(checkAutofill, 100);
        setTimeout(checkAutofill, 300);
        setTimeout(checkAutofill, 500);
        const observer = new MutationObserver(checkAutofill);
        inputs.forEach(input => {
            observer.observe(input, { attributes: true, attributeFilter: ['value'] });
        });
        return () => observer.disconnect();
    }, []);

    return (
        <div className="login-page">
            <div className="logos-grid">
                <div className="logo-container">
                    <div id="logoBig"></div>
                    <p className="logo-text">Centralisez. Automatisez. Gagnez du temps.</p>
                </div>
                <div id="digitartsDiv"></div>
            </div>
            {/* <Box sx={{ position: "absolute", top: 12, right: 12 }}>
                <LanguageSwitcher variant="login" />
            </Box> */}
            <Card
                sx={{
                    width: "90%",
                    maxWidth: { xs: "280px", sm: "340px", md: "400px" },
                    maxHeight: rememberedUsers.length > 0 ?
                        { xs: "420px", sm: "620px", md: "660px" }
                        : { xs: "350px", sm: "460px", md: "550px" },
                    backdropFilter: 'blur(10px)',
                    borderRadius: "24px",
                    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(255, 255, 255, 0.1)',
                    overflow: 'visible',
                    position: 'relative',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: -2,
                        left: -2,
                        right: -2,
                        bottom: -2,
                        background: theme.palette.background.cardBackground,
                        borderRadius: '26px',
                        zIndex: -1
                    }
                }}
            >
                <CardContent
                    sx={{
                        p: { xs: 1.25, sm: 2 },
                        display: 'flex',
                        marginTop: "24px !important",
                        height: rememberedUsers.length === 0
                            ? { xs: "auto", sm: "auto", md: "420px" }
                            : "auto",
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: { xs: '2px', sm: '4px' },
                        textAlign: 'center'
                    }}
                >

                    <Box id="MawaredLogo"></Box>
                    <Box sx={{ textAlign: 'center', mb: rememberedUsers.length === 0 ? "20px" : 0.5, mt: { xs: "-10px", sm: "3px" } }}>
                        <Typography
                            variant="h6"
                            component="h1"
                            sx={{
                                fontWeight: 700,
                                background: theme.palette.primary.main,
                                backgroundClip: 'text',
                                WebkitBackgroundClip: 'text',
                                color: 'transparent',

                                mb: 0.5,
                                fontSize: { xs: '14px', sm: '18px', md: '22px' },
                            }}
                        >
                            {t("login.welcome")}
                        </Typography>
                        <Typography variant="body1" color="text.secondary"
                            sx={{
                                fontSize: { xs: "0.70rem", sm: "0.80rem", md: "0.90rem" },
                                opacity: 0.8,
                                mb: rememberedUsers.length === 0 ? "10px" : 0,
                            }}>{t("login.subtitle")}</Typography>
                    </Box>
                    {rememberedUsers.length > 0 && (
                        <Box sx={{ textAlign: 'center', mb: 1.5 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: "10px", fontSize: { xs: "0.75rem", sm: "0.85rem" } }}>
                                {t("login.choose_user")}
                            </Typography>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Box sx={{ display: 'flex', ml: 1 }}>
                                    {rememberedUsers.map((user, index) => {
                                        const isSelected = selectedUser?.uid === user.uid;
                                        return (
                                            <Box key={user.uid} className="avatar-wrapper" sx={{ position: 'relative', ml: index > 0 ? -2 : 0 }}>
                                                <button className="delete-btn"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        const updatedUsers = rememberedUsers.filter(u => u.uid !== user.uid);
                                                        setRememberedUsers(updatedUsers);
                                                        window.location.reload();
                                                    }}
                                                > x </button>
                                                <Avatar
                                                    // key={user.uid}
                                                    // src={user.profileImage}
                                                    src={`${param.urlimg}${user.img}${user.nodes?.usr || '/user/'}${user.uid}.jpg`}

                                                    // src={
                                                    //     user.img && user.img !== "0"
                                                    //         ? `${param.urlimg}${user.img}${user.nodes?.usr || "/user/"}${user.uid}.jpg`
                                                    //         : `${param.urlimg}${user.nodes?.usr || "/user/"}${user.uid}.jpg`
                                                    // }
                                                    sx={{
                                                        width: { xs: 40, sm: 56 },
                                                        height: { xs: 40, sm: 56 },
                                                        border: isSelected ? '3px solid #338bbf' : 'white',
                                                        boxShadow: isSelected
                                                            ? '0 4px 16px rgba(51, 139, 191, 0.4)'
                                                            : '0 2px 8px rgba(0,0,0,0.15)',
                                                        cursor: 'pointer',
                                                        // ml: index > 0 ? -2 : 0,
                                                        transition: 'all 0.2s ease',
                                                        transform: isSelected ? 'scale(1.1) translateY(-4px)' : 'scale(1) translateY(0)',
                                                        zIndex: isSelected ? 10 : 1,
                                                        '&:hover': {
                                                            transform: 'scale(1.1) translateY(-4px)',
                                                            zIndex: 10,
                                                            boxShadow: '0 4px 16px rgba(51, 139, 191, 0.5)'
                                                        }
                                                    }}
                                                    onClick={() => {
                                                        setSelectedUser(user);
                                                        setEmail(user.nickname || user.email);
                                                        setTimeout(() => passwordRef.current?.focus(), 150);
                                                    }}
                                                    title={user.name}
                                                />
                                            </Box>
                                        );
                                    })}
                                </Box>
                            </Box>
                            <button
                                className="clear-btn"
                                onClick={() => {
                                    clearRememberedUsers();
                                    setRememberedUsersList([]);
                                }}
                            >
                                {t("login.clear_users")}
                            </button>
                        </Box>
                    )}

                    <Box component="form" onSubmit={handleSubmit}
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            flex: 1,
                            gap: { xs: "15px", sm: 2 },
                        }}
                    >
                        <DynamicField
                            fieldType="textfield"
                            label={t("login.your_login")}
                            id="iEmail"
                            name="email"
                            value={email}
                            onChange={(value) => setEmail(value.trim())}
                            required
                            autoFocus
                            fullWidth
                            InputProps={{
                                autoFocus: true,
                                sx: { height: { xs: 30, sm: 32, md: 35 } },
                            }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <DynamicField
                            fieldType="textfield"
                            type={showPassword ? "text" : "password"}
                            label={t("login.password")}
                            name="password"
                            value={password}
                            onChange={(value) => setPassword(value)}
                            required
                            fullWidth
                            autoComplete="current-password"
                            InputProps={{
                                sx: { height: { xs: 30, sm: 32, md: 35 } },
                                // ↓ swap position based on language
                                ...(isRtl
                                    ? {
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <IconButton
                                                    onClick={() => setShowPassword((prev) => !prev)}
                                                    edge="start"
                                                    sx={{ padding: 0, m: 0, transform: "translateX(4px)", "&:hover": { background: "transparent" } }}
                                                >
                                                    <Icon path={showPassword ? mdiEyeOff : mdiEye} size={1} color="#0075E3" />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }
                                    : {
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => setShowPassword((prev) => !prev)}
                                                    edge="end"
                                                    sx={{ padding: 0, m: 0, transform: "translateX(-4px)", "&:hover": { background: "transparent" } }}
                                                >
                                                    <Icon path={showPassword ? mdiEyeOff : mdiEye} size={1} color="#0075E3" />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }
                                ),
                            }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />

                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            sx={{
                                height: { xs: 30, sm: 32, md: 35 },
                                textTransform: 'uppercase',
                            }}
                        >
                            {isLoading ? t("login.loading") : t("login.submit")}
                        </Button>
                    </Box>

                    <Pwd param={param} email={email} />
                </CardContent>
            </Card>

            <div id="authBottom">
                <span id="copyr">{param.webApp} {version[0].build} &copy; {param.copyright}</span>
            </div>

        </div>
    );
};

export default Login;


